import { EllipseCurve } from 'three';
import { SVGResultPaths } from 'three/addons/loaders/SVGLoader.js';
import { sceneUnitsFromMm } from './scaler';

export function parseInsertionPointFromPath(svgPath: SVGResultPaths): { x: number; y: number } | null {

    if (svgPath.subPaths.length > 0 && svgPath.subPaths[0].curves.length > 0)
    {
        const curveNode = svgPath.subPaths[0].curves[0] as EllipseCurve;

        if (curveNode) {
            return {    x: sceneUnitsFromMm(curveNode.aX), 
                        y: sceneUnitsFromMm(curveNode.aY) };
        }
    }

    return null;
}

export function findPathsById(svgPaths: SVGResultPaths[], pathId: string) : SVGResultPaths[] {
    
    const insertionPointPaths = svgPaths.filter(p => p.userData?.node as SVGCircleElement !== undefined 
        && (p.userData?.node as SVGCircleElement).getAttribute("id") === pathId);

    return insertionPointPaths;
}